import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './CompaniesMarquee.css';

import ags from '../../assets/images/ags.png';
import movate from '../../assets/images/movate.png';
import manipal from '../../assets/images/manipal.png';
import pragma from '../../assets/images/pragma.png';
import allsec from '../../assets/images/allsec.png';
import hallmark from '../../assets/images/hallmark.png';
import hdfc from '../../assets/images/hdfc.png';
import axis from '../../assets/images/axis.png';
import backbase from '../../assets/images/backbase.png';
import debtcare from '../../assets/images/debtcare.png';
import alorica from '../../assets/images/alorica.png';
import intouch from '../../assets/images/intouch.png';
import greyt from '../../assets/images/greyt.png';
import idfc from '../../assets/images/idfc.png';
import marketstar from '../../assets/images/mark.png';
import sutherland from '../../assets/images/surherland.png';
import niit from '../../assets/images/niit.png';
import rays from '../../assets/images/rays.png';
import resultscx from '../../assets/images/resut.png';
import sbi from '../../assets/images/sbi.png';
import suitefy from '../../assets/images/suitefy.png';
import twenty from '../../assets/images/twenty.png';
import techmahindra from '../../assets/images/tech.png';
import unext from '../../assets/images/unext.png';

const logos = [
  { name: 'AGS Health', src: ags },
  { name: 'Movate', src: movate },
  { name: 'Manipal', src: manipal },
  { name: 'PragmaEdge', src: pragma },
  { name: 'Allsec Technologies', src: allsec },
  { name: 'Hallmark', src: hallmark },
  { name: 'HDFC Bank', src: hdfc },
  { name: 'Axis Bank', src: axis },
  { name: 'Backbase', src: backbase },
  { name: 'Debtcare', src: debtcare },
  { name: 'Alorica', src: alorica },
  { name: '24-7 Intouch', src: intouch },
  { name: 'GreytHR', src: greyt },
  { name: 'IDFC First Bank', src: idfc },
  { name: 'MarketStar', src: marketstar },
  { name: 'Sutherland', src: sutherland },
  { name: 'NIIT', src: niit },
  { name: 'Rays Power Infra', src: rays },
  { name: 'ResultsCX', src: resultscx },
  { name: 'SBI', src: sbi },
  { name: 'Suitefy', src: suitefy },
  { name: '24/7 AI', src: twenty },
  { name: 'Tech Mahindra Foundation', src: techmahindra },
  { name: 'Unext', src: unext },
];

const CompaniesMarquee = () => {
  const scrollRef = useRef(null);
  const loopLogos = [...logos, ...logos]; // duplicate for looping feel

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = direction === 'left' ? -300 : 300;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <section className="companies-section">
      <motion.h2
        className="companies-title"
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 1.6, ease: 'easeOut' }}
      >
        Companies We Work With
      </motion.h2>

      <div className="marquee-wrapper">
        <button
          className="arrow-button left"
          onClick={() => scroll('left')}
          aria-label="Scroll left"
        >
          <ChevronLeft size={24} />
        </button>

        <div className="marquee" ref={scrollRef}>
          <div className="marquee-track">
            {loopLogos.map((logo, idx) => (
              <div key={`${logo.name}-${idx}`} className="logo-card">
                <img src={logo.src} alt={`${logo.name} logo`} />
              </div>
            ))}
          </div>
        </div>

        <button
          className="arrow-button right"
          onClick={() => scroll('right')}
          aria-label="Scroll right"
        >
          <ChevronRight size={24} />
        </button>
      </div>
    </section>
  );
};

export default CompaniesMarquee;
